import React, { Component } from 'react';
import axios from 'axios';
import TableRow from './TableRow2';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import AssignmentIcon from '@material-ui/icons/Assignment';
import Fab from '@material-ui/core/Fab';
import EmisorIcon from '@material-ui/icons/AccountBoxRounded';
import TipoIcon from '@material-ui/icons/BookRounded';
import FechaIcon from '@material-ui/icons/EventRounded';
import Grid from '@material-ui/core/Grid';
import { makeStyles,styled } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Card from 'react-bootstrap/Card';

import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import NavigationIcon from '@material-ui/icons/Navigation';
import {Modal,Table} from 'react-bootstrap'
import { reporte} from '../../services/SecurityService';
import clsx from 'clsx';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import PageviewIcon from '@material-ui/icons/Pageview';
import {
  ExcelExport,
  ExcelExportColumn,
  ExcelExportColumnGroup,
} from "@progress/kendo-react-excel-export";
import ReactExport from "react-export-excel";
import styles2 from './VentanaPrincipal.css'

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const useStyles = makeStyles(theme => ({
  fab: {
    margin: theme.spacing(1),
  },
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
}));

const ColorButton = styled(Button)(({ theme }) => ({
  color: '#a02142',
  borderColor: '#a02142',
  '&:hover': {
    backgroundColor: '#a02142',
    color:'#ffffff'
  },
}));

const ColorButton2 = styled(Button)(({ theme }) => ({
  color: '#3cba54',
  borderColor: '#3cba54',
  '&:hover': {
    backgroundColor: '#3cba54',
    color:'#ffffff'
  },
}));



export default class VentanaPrincipal extends Component {
  
  

  constructor(props) {
      super(props);
      console.log("PPROPS")
      console.log(this.props)
      console.log(props)

      this.handleShow = this.handleShow.bind(this);

      this.handleShow2 = this.handleShow2.bind(this);
      this.handleClose2 = this.handleClose2.bind(this);
      this.onChangeBuscar = this.onChangeBuscar.bind(this);

      this.onChangeFechaFinal = this.onChangeFechaFinal.bind(this);
      this.onChangeFechaInicial = this.onChangeFechaInicial.bind(this);
      this.generarreporte=this.generarreporte.bind(this);

      let datea = new Date().getDate();
      let month = new Date().getMonth() + 1;
      let year = new Date().getFullYear();

if(month<10){month="0"+month;}
if(datea<10){datea="0"+datea;}
      let fechaRR =year+'-'+month+'-'+datea;

      this.state = {
        buscar : '',
        activado:false,
        FechaFinal:fechaRR,
        FechaInicial:'2021-03-19',
        excel:[],
        show:false,
        show2:false,
        bus : false,
        bs : [],
        oficiosR: this.props.oficiosEP,
        oficiosEP: this.props.oficiosEP,
        indice:this.props.indice,
        vacio : [{no_folio:"",emisor:"",Tipo:"",asunto:"",fecha_documento:"",fecha_documento:"",fecha_termino:"",
        usuarioSeguimiento:""}]
      };


    }

    onChangeBuscar(e){

      this.setState({
        buscar: e.target.value.toUpperCase()
      })
    }
    componentDidMount(){
      console.log("Aqui se imprimien los OficiosR y EP y usuario logueado")
      console.log(this.props)
      console.log(this.props.id_usuario)
      console.log(this.state.oficiosR)
      console.log(this.state.oficiosEP)
      this.setState({
       
      oficiosR : this.props.oficiosR,
      indice:this.props.indice,
      bus : true
      }); 
   
      console.log("--asdadas---------->>>>>>>>>>>>><INDEX");
      console.log(this.props.indice);
     
    }
    tabRow(){
 let ad = this.props.id_usuario;
 let ind=this.props.indice;

 let idusr=this.props.iduser;

 let colorb;


 if(ad==453 || ad==454 || ad==455){
  if(ind==0){
    colorb='info'
  }else if(ind==1){
   colorb='warning'
 }else if(ind==2){
   colorb='success'
 }else if(ind==3){
   colorb='danger'
 }else if(ind==4){
   colorb='secondary'
 }else if(ind==5){
   colorb='primary'
 }
 }else{
  if(ind==0){
    colorb='info'
  }else if(ind==1){
   colorb='success'
 }else if(ind==2){
   colorb='danger'
 }else if(ind==3){
   colorb='secondary'
 }else if(ind==4){
   colorb='primary'
 }
 }

      if(this.state.bus==false || this.state.buscar==""){

      if(this.props.oficiosR==null || this.props.oficiosR==="" || this.props.oficiosR=="OK" || this.props.oficiosR.fatal==false){
        return console.log("NO hay oficios");
      }
      else{
      return this.props.oficiosR.map(function(object, i){
          return <TableRow obj={object} key={i} user={ad} index={ind} iduser={idusr}  botoncolor={colorb}/>;
      });


    }

  } else if (this.state.bus==true){

    if(this.state.bs==null || this.state.bs==="" || this.state.bs=="OK" ){
      return console.log("NO hay oficios");
    }
    else{
    let f =this.props.oficiosR;
    let userL =this.props.id_usuario;
    let ind=this.props.indice;
    let idusrr=this.props.iduser;

    let colorb;


    if(userL==453 || userL==454 || userL==455){
      if(ind==0){
        colorb='info'
      }else if(ind==1){
       colorb='warning'
     }else if(ind==2){
       colorb='success'
     }else if(ind==3){
       colorb='danger'
     }else if(ind==4){
       colorb='secondary'
     }else if(ind==5){
       colorb='primary'
     }
     }else{
      if(ind==0){
        colorb='info'
      }else if(ind==1){
       colorb='success'
     }else if(ind==2){
       colorb='danger'
     }else if(ind==3){
       colorb='secondary'
     }else if(ind==4){
       colorb='primary'
     }
     }
    if(this.props.oficiosR!="No existen clientes en la BBDD."){
      if(ind==0){
        f= f.filter(d=> d.nombre.toUpperCase().includes(this.state.buscar.toUpperCase()) ||  d.ap_paterno.toUpperCase().includes(this.state.buscar.toUpperCase()) )

      }else{
        f= f.filter(d=> d.nombre.includes(this.state.buscar) ||  d.no_folio==this.state.buscar || (d.giros!=undefined && d.giros!=null && d.giros!='' ? d.giros.includes(this.state.buscar) : d.no_folio==this.state.buscar))

      }
    
    return f.map(function(object, i){
        return <TableRow obj={object} key={i} user={userL} index={ind} iduser={idusrr} botoncolor={colorb}/>;
    });
  }
  }
  }


  
    }

    handleShow() {
     
     console.log("buscar")
     console.log(this.state.buscar)
     console.log(this.state.oficiosR)
     this.setState({
       
      bus : true
      }); 
    }


    handleClose2() {
      this.setState({ show: false });
    }
  
    handleShow2() {
      this.setState({ show: true });
     
    }

    generarreporte(){
this.setState({
  activado:true,
  show2:false
});
      let a ={FechaFinal:this.state.FechaFinal, FechaInicial:this.state.FechaInicial}
console.log("datos")
      console.log(a);
      reporte(a).then(response => {

        let exp=[];
        response.forEach(function(element){
          let cc;
          if(element.RazonSocial==""){
            cc=element.RazonSocial2;
          }
          else{
            cc=element.RazonSocial;
          }

          let pcp="";
          let pcn="";
          if(element.P_CIVIL==5){
            pcp="S";
          }
          else{
            pcn="N";
          }

          let sp="";
          let sn="";
          if(element.SANIDAD==5){
            sp="S";
          }
          else{
            sn="N";
          }

          let ep="";
          let en="";
          if(element.ECOLOGIA==5){
            ep="S";
          }
          else{
            en="N";
          }

          let cp="";
          let cn="";
          if(element.COMP_URB==5){
            cp="S";
          }
          else{
            cn="N";
          }

          let com;

          if(element.Estatus==16){
            com="Licencia";
          }

          let ne={Folio: element.Folio,TipoPersona:element.TipoPersona,pcp:pcp,pcn:pcn,sp:sp,sn:sn,ep:ep,en:en,cp:cp,cn:cn,RazonSocial:cc,Giro:element.giros,NombreSolicitante:element.NombreSolicitante,Comentarios:com,Email:element.Email,Celular:element.Celular,FechaHoraRegistro:element.FechaHoraRegistro,Colonia:element.Colonia,Localidad:element.Localidad,FechaHoraAsistio:element.FechaHoraAsistio}
            exp.push(ne)
          
        })



        this.setState({
        
        excel:exp
        });
         console.log("r dideco")
         console.log(response)
         this.setState({show2:true,activado:false});
        }).catch(err => console.log(err)); 
    }
    
    onChangeFechaFinal(e) {
      this.setState({
      FechaFinal: e.target.value
      }) 

      console.log(e.target.value);
      }

      onChangeFechaInicial(e) {
        this.setState({
        FechaInicial: e.target.value
        }) 
        console.log(e.target.value);
        }

    render() {
      const _exporter = React.createRef();
      let obj={username : "desarrollo_economico", password:"u2yomty1gk"}
      let idc;
      let dd=this.props.indice;

      let idusr=this.props.id_usuario;

      let btnexp;
      
        btnexp=<ColorButton  onClick={this.handleShow2} variant="outlined" ><PageviewIcon/>&nbsp;
Reporte </ColorButton>
      

      const excelExport = () => {
        save(_exporter);
      };

      const save = component => {
        const options = component.current.workbookOptions();
        const rows = options.sheets[0].rows;
    
        rows.forEach(row => {
       
          if (row.type === 'data') {
            row.cells.forEach(cell => {
              if (cell.value == "S") {
                cell.background = '#1b5fe8';
              }else if (cell.value == "N") {
                cell.background = '#db1c1c';
              }
              else if (cell.value == "Licencia") {
                cell.background = '#279fb5';
              }
            });
    
        
          }
        });
        component.current.save(options);
      };
    
      





      let colorI;

      if(this.props.id_usuario==453 || this.props.id_usuario==454 || this.props.id_usuario==455){
      if(this.props.indice==0){
        colorI='#00A6A7';
      }else if(this.props.indice==1){
        colorI='#F4B223';
      }else if(this.props.indice==2){
        colorI='#44AC34';
      }else if(this.props.indice==3){
        colorI='#D3065B';
      }else if(this.props.indice==4){
        colorI='#606060';
      }
      else if(this.props.indice==5){
        colorI='#274178';
      }}else{
        if(this.props.indice==0){
          colorI='#00A6A7';
        }else if(this.props.indice==1){
          colorI='#44AC34';
        }else if(this.props.indice==2){
          colorI='#D3065B';
        }else if(this.props.indice==3){
          colorI='#606060';
        }
        else if(this.props.indice==4){
          colorI='#274178';
        }
      }
      return (
        
        <div className={styles2}>

          
        <div align="right"></div>
        
        
        <TextField
        id="standard-with-placeholder"
        label="Filtro de Busqueda"
        type="search"
        placeholder="Buscar"
        value={this.state.buscar}
        onChange={this.onChangeBuscar}
        margin="normal"
       
      />
      {/*
      <Button  onClick={this.handleShow} className="btn btn-success">
                Buscar <AddIcon /></Button>
                    <Link rel ="noopener noreferrer" to={'didec/login/'+obj.username+'/'+obj.password} target="_blank"  className="btn btn-outline-success">Logueo2</Link>
          */ }

<Card style={{borderRadius:'12px'}}>
<div class="table-responsive" style={{borderRadius:'12px'}}>
          <Table size='md'   style={{marginLeft:'1px',marginTop:'1px',marginRight:'3px'}}>
            <thead >
              <tr  style={{thead:'light',textAlign:'center'}} >
               {(this.props.tipo==1 && this.props.indice!=0) || (this.props.tipo==2) ?<th style={{color:'#495057',fontWeight:'bold',backgroundColor:'#E9ECEF'}} width="10%">Matricula &nbsp;
                <TipoIcon />
                </th>:null}
                <th  style={{color:'#495057',fontWeight:'bold',backgroundColor:'#E9ECEF'}} width="12%">APELLIDO PATERNO &nbsp;
                <EmisorIcon extendedIcon />
                </th>
                <th style={{ color:'#495057',fontWeight:'bold',backgroundColor:'#E9ECEF'}} width="12%">APELLIDO MATERNO &nbsp;
                <EmisorIcon extendedIcon />
                </th>
                
                <th style={{ color:'#495057',fontWeight:'bold',backgroundColor:'#E9ECEF'}} width="12%">Nombre &nbsp;
                <EmisorIcon extendedIcon />
                </th>
                <th style={{ color:'#495057',fontWeight:'bold',backgroundColor:'#E9ECEF'}} width="12%">Fecha Nacimiento &nbsp;
                <FechaIcon extendedIcon />
                </th>
               
                <th style={{ color:'#495057',fontWeight:'bold',backgroundColor:'#E9ECEF'}} width="12%">ESTADO CIVIL &nbsp;
                <EmisorIcon extendedIcon />
                </th>
                <th style={{ color:'#495057',fontWeight:'bold',backgroundColor:'#E9ECEF'}} width="12%">OCUPACIÓN &nbsp;
                <EmisorIcon extendedIcon /></th>

                <th style={{ color:'#495057',fontWeight:'bold',backgroundColor:'#E9ECEF'}} width="12%">Fecha Cita &nbsp;
                <FechaIcon extendedIcon /></th>

    
              </tr>
            </thead>
            <tbody>
              {this.tabRow()}
            </tbody>
          </Table>
          </div>
          </Card>
          <>
            
      
                <Modal 
               size="xl"
               aria-labelledby="contained-modal-title-vcenter"
               dialogClassName="modal-90w"
               centered
              
              show={this.state.show} onHide={this.handleClose2} >
                <Modal.Header closeButton  style={{backgroundColor:'#a02142',color:'white'}} closeVariant='white'>
                <Modal.Title>Reporte </Modal.Title>
                </Modal.Header>
                <Modal.Body>

                <Grid container spacing={2} >
                <Grid item xs={6}>
                <label>FECHA INICIAL:  </label>
               
                <input 
      type="date" 
      className="form-control" 
      value={this.state.FechaInicial}
      onChange={this.onChangeFechaInicial}
     
     
     
      />
      
      </Grid>
      <Grid item xs={6}>
                <label>FECHA FINAL:  </label>
               
                <input 
      type="date" 
      className="form-control" 
      value={this.state.FechaFinal}
      onChange={this.onChangeFechaFinal}
     
     
     
      />
      
      </Grid>
      </Grid>
              
                </Modal.Body>
                <Modal.Footer>

                  { this.state.show2==true ?  [ 
               
                 
            <ColorButton  onClick={excelExport} variant="outlined">Exportar Excel</ColorButton>,

      <ExcelExport data={this.state.excel} fileName={this.state.FechaFinal+"_dideco.xlsx"} ref={_exporter}>
        <ExcelExportColumn field="Folio" title="Folio" headerCellOptions={{
            textAlign: "center"
          }}/>
        <ExcelExportColumn field="TipoPersona" title="RS" headerCellOptions={{
            textAlign: "center"
          }}/>
        <ExcelExportColumnGroup
          title="P. CIVIL"
          headerCellOptions={{
            textAlign: "center",
            background: "#e88484",
          }}

        >
          <ExcelExportColumn field="pcp" title="P" width={'50%'} headerCellOptions={{
            textAlign: "center"
          }}/>
          <ExcelExportColumn field="pcn" title="N" width={'50%'} headerCellOptions={{
            textAlign: "center"
          }}/>
        </ExcelExportColumnGroup>

        <ExcelExportColumnGroup
          title="SANIDAD"
          headerCellOptions={{
            textAlign: "center",
            background: "#79b1f7",
          }}

        >
          <ExcelExportColumn field="sp" title="P" width={'50%'} headerCellOptions={{
            textAlign: "center"
          }}/>
          <ExcelExportColumn field="sn" title="N" width={'50%'} headerCellOptions={{
            textAlign: "center"
          }}/>
        </ExcelExportColumnGroup>

        <ExcelExportColumnGroup
          title="ECOLOGIA"
          headerCellOptions={{
            textAlign: "center",
            background: "#a4dd94",
          }}

        >
          <ExcelExportColumn field="ep" title="P" width={'50%'} headerCellOptions={{
            textAlign: "center"
          }}/>
          <ExcelExportColumn field="en" title="N" width={'50%'} headerCellOptions={{
            textAlign: "center"
          }}/>
        </ExcelExportColumnGroup>

        <ExcelExportColumnGroup
          title="COMP URB"
          headerCellOptions={{
            textAlign: "center",
            background: "#2e771a",
          }}

        >
          <ExcelExportColumn field="cp" title="P" width={'50%'} headerCellOptions={{
            textAlign: "center"
          }}/>
          <ExcelExportColumn field="cn" title="N" width={'50%'} headerCellOptions={{
            textAlign: "center"
          }}/>
        </ExcelExportColumnGroup>



        <ExcelExportColumn field="RazonSocial" title="Razon Social" headerCellOptions={{
            textAlign: "center"
          }}/>
        <ExcelExportColumn field="Giro" title="Giro" headerCellOptions={{
            textAlign: "center"
          }}/>
        <ExcelExportColumn field="NombreSolicitante" title="Nombre Solicitante" headerCellOptions={{
            textAlign: "center"
          }}/>
        <ExcelExportColumn field="Comentarios" title="Comentarios" headerCellOptions={{
            textAlign: "center"
          }}/>
        <ExcelExportColumn field="Email" title="Email" headerCellOptions={{
            textAlign: "center"
          }}/>
        <ExcelExportColumn field="Celular" title="Celular" headerCellOptions={{
            textAlign: "center"
          }}/>
        <ExcelExportColumn field="FechaHoraRegistro" title="Fecha Hora Registro" headerCellOptions={{
            textAlign: "center"
          }}/>
        <ExcelExportColumn field="Colonia" title="Colonia" headerCellOptions={{
            textAlign: "center"
          }}/>
        <ExcelExportColumn field="Localidad" title="Localidad" headerCellOptions={{
            textAlign: "center"
          }}/>
        <ExcelExportColumn field="FechaHoraAsistio" title="Fecha Hora Asistio" headerCellOptions={{
            textAlign: "center"
          }}/>

      </ExcelExport>
                    ] : null }&nbsp;
               <ColorButton2  onClick={this.generarreporte}  disabled={this.state.activado} variant="outlined">Generar</ColorButton2>
               
                  
                  </Modal.Footer>
              </Modal>
            </>


        </div>
      );
    }
  }